import React from "react";
import "react-chat-widget/lib/styles.css";

import PropTypes from "prop-types";

export const ChatOldMessage = ({ message, time }) => {
  return (
    <div className="rcw-message">
      <img src="/no_profile.png" className="rcw-avatar" alt="avatar" />
      <div className="rcw-response">
        <div className="rcw-message-text">
          <p>{message}</p>
        </div>
        <span className="rcw-timestamp">{time}</span>
      </div>
    </div>
  );
};
ChatOldMessage.propTypes = {
  message: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
};
